import { render, staticRenderFns } from "./DoctorContactsList.vue?vue&type=template&id=52e0dcf6&"
import script from "./DoctorContactsList.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DoctorContactsList.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52e0dcf6')) {
      api.createRecord('52e0dcf6', component.options)
    } else {
      api.reload('52e0dcf6', component.options)
    }
    module.hot.accept("./DoctorContactsList.vue?vue&type=template&id=52e0dcf6&", function () {
      api.rerender('52e0dcf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/DoctorContacts/components/DoctorContactsList.vue"
export default component.exports